import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Carousel from 'react-bootstrap/Carousel';
import Image from 'react-bootstrap/Image';

const SlideshowGallery = ({ data }) => {
 const galleryImages = data.galleryImages;

 return (
  <Container className='d-inline-block'>
   <Row>
    <Col>
     <Carousel controls={true} fade>
      {galleryImages.map((image, index) => (
       <Carousel.Item key={index} interval={3000}>
        <div className='gallery-ratio gallery-ratio-16x9'>
         <Image
          className='d-block w-100 gallery-img-centered'
          src={image}
          alt='Gallery Image'
          fluid
         />
        </div>
       </Carousel.Item>
      ))}
     </Carousel>
    </Col>
   </Row>
  </Container>
 );
};

export default SlideshowGallery;
